module.exports = __webpack_public_path__ + "static/media/porcentagem.8fb622d8.svg";